import { useEffect, useState } from 'react';
import QRCodeLib from 'qrcode';
import './PhoneMock3D.css';

// Генерация хеша для QR-кода
function generateHash(): string {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 15);
  const data = `RECVISIT-${timestamp}-${random}`;
  
  let hash = 0;
  for (let i = 0; i < data.length; i++) {
    const char = data.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  
  return `0x${Math.abs(hash).toString(16).padStart(8, '0')}`;
}

export default function PhoneMock3D() {
  const [qrDataUrl, setQrDataUrl] = useState<string>('');
  const [hash, setHash] = useState<string>('');
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const generateQR = async () => {
      const newHash = generateHash();
      const data = `RECVISIT:${newHash}:${Date.now()}`;
      
      try {
        const url = await QRCodeLib.toDataURL(data, {
          width: 400,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          },
          errorCorrectionLevel: 'H'
        });
        
        return { url, hash: newHash };
      } catch (error) {
        console.error('Error generating QR code:', error);
        return null;
      }
    };

    const initQR = async () => {
      const result = await generateQR();
      if (result) {
        setQrDataUrl(result.url);
        setHash(result.hash);
      }
    };

    initQR();

    const interval = setInterval(async () => {
      setIsTransitioning(true);
      
      setTimeout(async () => {
        const result = await generateQR();
        if (result) {
          setQrDataUrl(result.url);
          setHash(result.hash);
        }
        setIsTransitioning(false);
      }, 400);
    }, 5000);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <div className="phone-mock-3d">
      <div className="phone-frame">
        {/* Динамическая островная часть */}
        <div className="phone-notch">
          <div className="notch-camera"></div>
        </div>
        
        {/* Экран телефона */}
        <div className="phone-screen">
          {/* Статус бар */}
          <div className="phone-status-bar">
            <div className="status-time">9:41</div>
            <div className="status-indicators">
              <div className="status-battery">
                <div className="battery-level"></div>
              </div>
            </div>
          </div>

          {/* Контент приложения */}
          <div className="phone-app-content">
            <div className="app-header">
              <div className="app-logo">RECVISIT</div>
            </div>

            <div className={`qr-container-3d ${isTransitioning ? 'transitioning' : ''}`}>
              {qrDataUrl && (
                <img 
                  src={qrDataUrl} 
                  alt="QR Code" 
                  className="qr-image-3d"
                />
              )}
              <div className="qr-glow"></div>
            </div>

            <div className="qr-hash-display">
              <code>{hash}</code>
            </div>

            <div className="status-indicator">
              <div className="status-dot"></div>
              <span>Готов к сканированию</span>
            </div>
          </div>

          {/* Нижняя панель */}
          <div className="phone-bottom-bar">
            <div className="home-indicator"></div>
          </div>
        </div>

        {/* Кнопки */}
        <div className="phone-button phone-button-power"></div>
        <div className="phone-button phone-button-volume-up"></div>
        <div className="phone-button phone-button-volume-down"></div>
      </div>

      {/* Тень */}
      <div className="phone-shadow"></div>
    </div>
  );
}

